import { render, staticRenderFns } from "./BeaconCarried.vue?vue&type=template&id=a6f98098&"
import script from "./BeaconCarried.vue?vue&type=script&lang=ts&"
export * from "./BeaconCarried.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports